import { useListing } from '../listing/useListing';

export function useBoardCardListing(card, options) {
    const listingId = card && card?.content?.encoded_id;

    return useListing(listingId, options);
}
